import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DispositivosComponent } from './dispositivos.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule } from '@po-ui/ng-templates';
import { DispositivosEditComponent } from './dispositivos-edit/dispositivos-edit.component';



@NgModule({
  declarations: [DispositivosComponent, DispositivosEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModule,
    PoPageDynamicEditModule
  ]
})
export class DispositivosModule { }

